export const initialState = {
    items: [],
    status: 'idle',
    error: null,
    hasCertificates: false,
    cryptoType: undefined,
};
